<section class="header px-xl-5 px-lg-4 px-md-3 px-sm-2 px-1">
  <a routerLink="/" class="brand">
    <img
      class="brand-img"
      src="assets/images/guavapay-arafikicompany.png"
      alt="Guavapay"
    />
  </a>

  <a href="/" class="back-link">
    <i class="fa fa-arrow-left"></i>
    Back to home page
  </a>
</section>
<div class="w-100 h-100 d-flex flex-column flex-grow-1 getting-started-bg">
  <div class="flex-grow-1"></div>
  <div class="w-100 px-1 px-xm-2 px-md-3 px-lg-4 px-xl-5 pb-5 mb-5">
    <h1 class="heading d-block text-primary">Welcome to<br />GuavaPay</h1>
    <h4 class="subheading">Let us get you started</h4>
    <div class="py-5">
      <div class="product-links">
       
        <a class="product-link" [class.disabled]="false"  href="http://groupsvr.guava.africa:8055/auth/login" target="_blank" rel="noopener noreferrer">
          <svg
            class="product-img"
            enable-background="new 0 0 511 511"
            height="48"
            viewBox="0 0 511 511"
            width="48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="m465.5 450.664v-31.381c16.957-3.48 29.749-18.52 29.749-36.49 0-20.539-16.709-37.249-37.249-37.249s-37.249 16.71-37.249 37.249c0 17.971 12.792 33.01 29.749 36.49v31.381h-44.762v-405.328h-210.014v64.066l-89.974 67.01v274.252h-45.583v-31.381c16.957-3.48 29.749-18.52 29.749-36.49 0-20.539-16.71-37.249-37.249-37.249s-37.249 16.71-37.249 37.249c0 17.971 12.792 33.01 29.749 36.49v31.381h-45.167v15h511v-15zm-29.748-67.871c0-12.269 9.98-22.249 22.249-22.249s22.249 9.98 22.249 22.249-9.98 22.249-22.249 22.249-22.249-9.98-22.249-22.249zm-405.334 0c0-12.269 9.98-22.249 22.249-22.249s22.249 9.98 22.249 22.249-9.981 22.249-22.249 22.249-22.249-9.98-22.249-22.249zm90.332-187.115h59.25v-15h-54.865l70.589-52.572v262.054h15v-276.992-14.938-37.894h180.014v45.332h-165.738v15h165.738v329.996h-15.75v-75.005h-149.515v75.005h-14.749v-15.504h-15v15.504h-74.974zm239.238 254.986h-119.515v-60.005h119.515z"
              />
              <path d="m195.724 405.16h15v15h-15z" />
              <path
                d="m135.5 210.681v44.997h44.997v-44.997zm29.997 29.997h-14.997v-14.997h14.997z"
              />
              <path
                d="m135.5 315.679h44.997v-44.997h-44.997zm15-29.997h14.997v14.997h-14.997z"
              />
              <path
                d="m135.5 375.679h44.997v-44.996h-44.997zm15-29.996h14.997v14.996h-14.997z"
              />
              <path
                d="m135.5 435.68h44.997v-44.997h-44.997zm15-29.997h14.997v14.997h-14.997z"
              />
              <path
                d="m255 165.012h-14.527v-14.333h119.515v14.333h-89.988v15h104.988v-44.333h-149.515v44.333h29.527z"
              />
              <path
                d="m374.988 196.022h-29.988v15h14.988v14.332h-119.515v-14.332h90.258v-15h-105.258v44.332h149.515z"
              />
              <path
                d="m374.988 255.365h-104.988v15h89.988v15.333h-119.515v-15.333h14.527v-15h-29.527v45.333h149.515z"
              />
              <path
                d="m374.988 315.709h-29.988v15h14.988v15.333h-119.515v-15.333h89.527v-15h-104.527v45.333h149.515z"
              />
              <path d="m263.231 75h15v15h-15z" />
              <path d="m293.231 75h15v15h-15z" />
              <path d="m323.231 75h15v15h-15z" />
            </g>
          </svg>
          <span class="product-title">Enterprise</span>
        </a>

        <a class="product-link" [class.disabled]="false" href="http://groupsvr.guava.africa:8056/home" target="_blank" rel="noopener noreferrer">
          <svg
            class="product-img"
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            version="1.1"
            viewBox="0 0 937.5 937.5"
            width="48"
          >
            <g id="surface1">
              <path
                d="M 781.25 165.53125 L 781.25 78.125 C 781.195312 35 746.25 0.0546875 703.125 0 L 78.125 0 C 35 0.0546875 0.0546875 35 0 78.125 L 0 421.875 C 0.121094 461.777344 30.367188 495.148438 70.0625 499.195312 L 128.796875 651.660156 C 144.3125 691.917969 189.523438 711.972656 229.785156 696.476562 L 596.5625 555.1875 C 571.21875 621.386719 578.429688 695.648438 616.023438 755.738281 L 625 770.09375 L 625 921.875 C 625 930.507812 631.992188 937.5 640.625 937.5 L 921.875 937.5 C 930.507812 937.5 937.5 930.507812 937.5 921.875 L 937.5 406.113281 C 937.351562 352.078125 915.839844 300.304688 877.636719 262.089844 Z M 781.25 258.976562 L 828.671875 382.078125 C 837.964844 406.242188 825.921875 433.355469 801.761719 442.65625 L 774.65625 453.125 C 778.984375 443.273438 781.226562 432.625 781.25 421.875 Z M 31.25 421.875 L 31.25 78.125 C 31.25 52.242188 52.242188 31.25 78.125 31.25 L 703.125 31.25 C 729.007812 31.25 750 52.242188 750 78.125 L 750 177.4375 L 749.863281 177.4375 L 750 177.792969 L 750 421.875 C 749.878906 424.601562 749.523438 427.304688 748.9375 429.96875 L 605.8125 286.828125 C 573.640625 255.398438 522.351562 255.15625 489.890625 286.257812 C 457.421875 317.378906 455.472656 368.628906 485.5 402.105469 L 546.515625 468.75 L 78.125 468.75 C 52.242188 468.75 31.25 447.757812 31.25 421.875 Z M 231.421875 500 L 120.3125 542.777344 L 103.875 500 Z M 218.546875 667.308594 C 194.390625 676.621094 167.261719 664.578125 157.953125 640.421875 L 131.59375 571.875 L 318.109375 500 L 318.109375 499.90625 L 575.15625 499.90625 L 595.464844 522.046875 Z M 906.25 906.25 L 656.25 906.25 L 656.25 781.25 L 906.25 781.25 Z M 906.25 750 L 649.296875 750 L 642.519531 739.171875 C 604.421875 678.289062 602.90625 601.390625 638.5625 539.0625 C 641.9375 533.164062 641.109375 525.757812 636.515625 520.75 L 508.472656 381.0625 C 489.378906 360.164062 490.453125 327.855469 510.894531 308.28125 C 531.34375 288.703125 563.667969 289.023438 583.714844 308.992188 L 832.703125 557.921875 L 854.796875 535.828125 L 796.984375 478.015625 L 813.015625 471.765625 C 853.242188 456.246094 873.289062 411.074219 857.8125 370.824219 L 804.925781 233.496094 L 855.542969 284.21875 C 887.886719 316.554688 906.125 360.375 906.25 406.113281 Z M 906.25 750 "
              />
              <path
                d="M 178.125 218.75 C 200.5625 218.75 218.75 200.5625 218.75 178.125 L 218.75 103.125 C 218.75 80.6875 200.5625 62.5 178.125 62.5 L 103.125 62.5 C 80.6875 62.5 62.5 80.6875 62.5 103.125 L 62.5 178.125 C 62.5 200.5625 80.6875 218.75 103.125 218.75 Z M 93.75 178.125 L 93.75 156.25 L 125 156.25 L 125 125 L 93.75 125 L 93.75 103.125 C 93.75 97.949219 97.949219 93.75 103.125 93.75 L 178.125 93.75 C 183.300781 93.75 187.5 97.949219 187.5 103.125 L 187.5 125 L 156.25 125 L 156.25 156.25 L 187.5 156.25 L 187.5 178.125 C 187.5 183.300781 183.300781 187.5 178.125 187.5 L 103.125 187.5 C 97.949219 187.5 93.75 183.300781 93.75 178.125 Z M 93.75 178.125 "
              />
              <path
                d="M 78.125 265.625 L 140.625 265.625 L 140.625 296.875 L 78.125 296.875 Z M 78.125 265.625"
              />
              <path
                d="M 78.125 359.375 L 140.625 359.375 L 140.625 390.625 L 78.125 390.625 Z M 78.125 359.375"
              />
              <path
                d="M 359.375 359.375 L 421.875 359.375 L 421.875 390.625 L 359.375 390.625 Z M 359.375 359.375"
              />
              <path
                d="M 171.875 265.625 L 234.375 265.625 L 234.375 296.875 L 171.875 296.875 Z M 171.875 265.625"
              />
              <path
                d="M 265.625 265.625 L 328.125 265.625 L 328.125 296.875 L 265.625 296.875 Z M 265.625 265.625"
              />
              <path
                d="M 359.375 265.625 L 421.875 265.625 L 421.875 296.875 L 359.375 296.875 Z M 359.375 265.625"
              />
              <path
                d="M 656.25 78.125 L 687.5 78.125 L 687.5 125 L 656.25 125 Z M 656.25 78.125"
              />
              <path
                d="M 593.75 78.125 L 625 78.125 L 625 125 L 593.75 125 Z M 593.75 78.125"
              />
              <path
                d="M 531.25 78.125 L 562.5 78.125 L 562.5 125 L 531.25 125 Z M 531.25 78.125"
              />
              <path
                d="M 468.75 78.125 L 500 78.125 L 500 125 L 468.75 125 Z M 468.75 78.125"
              />
              <path
                d="M 687.5 812.5 L 718.75 812.5 L 718.75 843.75 L 687.5 843.75 Z M 687.5 812.5"
              />
            </g>
          </svg>
          <span class="product-title">Individual</span>
        </a>

        <a class="product-link" routerLink="/auth/register-crms">
          <svg
            class="product-img"
            enable-background="new 0 0 64 64"
            height="48"
            viewBox="0 0 64 64"
            width="48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m4 62h6c1.103 0 2-.897 2-2v-2h22.606c5.024 0 9.933-1.408 14.193-4.07 6.423-4.015 10.862-10.596 12.179-18.056l.434-2.458c.194-1.098-.105-2.218-.822-3.072s-1.768-1.344-2.883-1.344c-.609 0-1.189.151-1.707.415v-4.415h1c.404 0 .77-.244.924-.617.155-.374.069-.804-.217-1.09l-8-8c-.391-.391-1.023-.391-1.414 0l-2.293 2.293v-13.586c0-.552-.447-1-1-1h-10c-.553 0-1 .448-1 1v11h-4.052c-.761-1.674-1.324-2.653-1.776-3.221l2.527-6.176c.281-.675.117-1.434-.418-1.933-.535-.5-1.304-.609-1.957-.283l-1.891.945-1.191-1.588c-.301-.402-.761-.654-1.262-.69-.502-.037-.993.146-1.352.503l-1.521 1.52-.999-1.333c-.302-.403-.762-.654-1.264-.69-.501-.037-.994.147-1.35.503l-1.919 1.919-2.884-.824c-.677-.194-1.392.036-1.829.583-.438.547-.505 1.298-.17 1.911l3.024 5.583c-2.123 1.918-4.716 7.307-4.716 12.204v3.067c0 3.309 2.691 6 6 6h11 9 8 10.382l-2.112 4.225-5.499 2.357c-.617-2.063-2.51-3.582-4.771-3.582h-14.397c-5.204 0-10.211 1.434-14.603 4.146v-2.146c0-1.103-.897-2-2-2h-6c-1.103 0-2 .897-2 2v22c0 1.103.897 2 2 2zm11.177-55.557c.605.173 1.258.005 1.702-.441l1.813-1.813 1 1.335c.303.402.764.654 1.266.689.508.033.992-.149 1.347-.504l1.521-1.52 1.141 1.52c.501.672 1.409.888 2.162.512l1.455-.728-2.256 5.507h-2.71l1.276-2.553-1.789-.895-1.723 3.448h-1.753l-1.394-2.9-1.803.867.977 2.033h-1.814l-2.843-5.25zm9.823 9.557v15h-10c-2.206 0-4-1.794-4-4v-3.067c0-5.353 3.313-10.345 4.261-10.933h11.327c.162.196.529.722 1.15 2h-1.738c-.553 0-1 .448-1 1zm2 1h7v14h-7zm22 .414 5.586 5.586h-11.172zm-13-12.414h8v14.586l-3.707 3.707c-.286.286-.372.716-.217 1.09.154.373.52.617.924.617h1v6h-6zm8 20h10v6h-2v-4c0-.552-.447-1-1-1h-4c-.553 0-1 .448-1 1v4h-2zm6 6h-2v-3h2zm-23.397 7h14.397c1.654 0 3 1.346 3 3s-1.346 3-3 3h-16v2h16c2.521 0 4.591-1.882 4.93-4.311l6.463-2.77c.218-.093.396-.26.501-.472l3.236-6.473c.302-.601.905-.974 1.577-.974.522 0 1.015.229 1.351.63s.477.925.386 1.439l-.434 2.458c-1.219 6.903-5.326 12.992-11.271 16.707-3.942 2.464-8.483 3.766-13.133 3.766h-22.606v-13.462c4.319-2.962 9.353-4.538 14.603-4.538zm-22.603 0h6l.001 22h-6.001z"
            />
            <path d="m6 41h2v3h-2z" />
            <path d="m38 7h1v2h-1z" />
            <path d="m41 7h1v2h-1z" />
            <path d="m38 11h1v2h-1z" />
            <path d="m41 11h1v2h-1z" />
            <path d="m38 15h1v2h-1z" />
            <path d="m41 15h1v2h-1z" />
            <path d="m29 19h1v2h-1z" />
            <path d="m32 19h1v2h-1z" />
            <path d="m29 23h1v2h-1z" />
            <path d="m32 23h1v2h-1z" />
            <path d="m29 27h1v2h-1z" />
            <path d="m32 27h1v2h-1z" />
            <path d="m38 19h1v2h-1z" />
            <path d="m41 19h1v2h-1z" />
            <path
              d="m22 18h-1v-1h-2v1h-1c-.553 0-1 .448-1 1v3c0 .552.447 1 1 1h3v1h-4v1c0 .552.447 1 1 1h1v1h2v-1h1c.553 0 1-.448 1-1v-3c0-.552-.447-1-1-1h-3v-1h4v-1c0-.552-.447-1-1-1z"
            />
            <path d="m53 4h2v2h-2z" />
            <path d="m55 2h2v2h-2z" />
            <path d="m57 4h2v2h-2z" />
            <path d="m55 6h2v2h-2z" />
            <path d="m60 9h2v2h-2z" />
            <path d="m53 12h2v2h-2z" />
            <path d="m2 11h2v2h-2z" />
            <path d="m4 9h2v2h-2z" />
            <path d="m6 11h2v2h-2z" />
            <path d="m4 13h2v2h-2z" />
            <path d="m2 19h2v2h-2z" />
            <path d="m6 2h2v2h-2z" />
          </svg>
          <span class="product-title">CRMS</span>
        </a>
      </div>
    </div>
  </div>
  <div class="py-5"></div>
</div>
